import { CommonModule } from "@angular/common";
import { ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from "@angular/core";
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { IonicModule, PopoverController } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

//Models
import { LicenseTypes } from "@models/MasterData";
import { EventTypes } from "@models/TrackingEvents";

//Services
import { EventsService } from "@providers/EventsService";
import { MessageService } from "@providers/MessageService";
import { NavService } from "@providers/NavService";

import { TrackingService } from "@providers/TrackingService";
import { UserServiceMSO } from "@providers/UserServiceMSO";

import { FormsModule } from "@angular/forms";
import { TypeLogout } from "@models/I_DecouplingLogout";
import { GlobalVarsModel } from "@models/ModelGlobalsVar";
import { CodereTimerComponent } from "@mso-components/codere-timer/codere-timer.component";
import { ParseMoney } from "@pipes/parseMoney";
import { PipesModule } from "@pipes/pipes.module";
import { BalancesService } from "@providers/BalancesService";
import { NewBaseService } from "@providers/newBase.service";
import { DeviceService } from "@services/device.service";
import { CASINO_PATHS, MSO_PATHS, PAYMENTS_PATHS, SPORTS_PATHS } from "@shared-constants/routes";
import { TicketService } from "@sports-services/index";
import { Utils } from "@utils/Utils";
import { Subscription, filter, take } from "rxjs";

@Component({
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    PipesModule,
    TranslateModule,
    ParseMoney,
    FormsModule,
    CodereTimerComponent,
  ],
  selector: "codere-navbar-pc",
  templateUrl: "./codere-navbar-pc.html",
  styleUrls: ["./codere-navbar-pc.scss"],
})
export class CodereNavbarPc implements OnInit, OnDestroy {
  messageCount: number | null | undefined;
  headerImg: {
    imgSrc: string;
    imgSrcCas: string;
    imgSrcSport: string;
    imgClass: { sport: string; casino: string; common: string };
  } = {
    imgSrc: "",
    imgSrcCas: "",
    imgSrcSport: "",
    imgClass: { sport: "", casino: "", common: "" },
  };
  isCasinoUrl: boolean = false;
  globalVars!: GlobalVarsModel;
  readonly licenseType = LicenseTypes;

  translate = inject(TranslateService);
  router = inject(Router);
  utils = inject(Utils);
  balancesService = inject(BalancesService);
  ticketService = inject(TicketService);
  events = inject(EventsService);
  navService = inject(NavService);
  userServiceMSO = inject(UserServiceMSO);
  messageService = inject(MessageService);
  trackingService = inject(TrackingService);
  newBaseService = inject(NewBaseService);
  cdr = inject(ChangeDetectorRef);
  deviceService = inject(DeviceService);
  popoverController = inject(PopoverController);

  //#endregion
  isMobile = this.deviceService.isMobile();
  popoverName: string;

  private subscriptions: Subscription[] = [];

  constructor() {
    this.subscriptions.push(
      this.newBaseService.getVars.subscribe((data) => {
        this.globalVars = data;
      }),
      this.balancesService.getPopoverName().subscribe((data) => {
        this.popoverName = data;
      }),
    );

    this.utils.openAccder$.subscribe((data) => {
      //** TODO */
      // this.openModalLogin({ activeSection: 2 })
      //Debería ir a confirmar contraseñas
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  ngOnInit() {
    if (this.globalVars.FEATURES.messageServiceEnabled) {
      this.messageService.messageCount.subscribe((data) => {
        this.messageCount = data;
      });
    }
    if (this.globalVars.FEATURES.MSO_NewReBranding) {
      this.subscriptions.push(
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
          this.isCasinoUrl = event["url"].startsWith(`/${CASINO_PATHS.BASE}`);
        }),
      );
    }
    this.changeLogo();
  }

  navigate(component: any, params?: any, left = false) {
    if (left) {
      this.navService.updateNavLeft(component.componentName);
    }

    const item = this.navService.navSectionsLeft.find(
      (itemN) => itemN.componentName === component.componentName && itemN.translate === component.translate,
    );
    params = item && item.params ? item.params : undefined;

    if (item.path === "casino/CasinoenVivoPage") {
      item.path = `${CASINO_PATHS.BASE}/${CASINO_PATHS.CasinoEnVivoPage}`;
    }

    const path: string = item.path;
    if (path.includes("casino")) {
      this.router.navigate([`/${path}`], { queryParams: params });
    } else {
      this.router.navigate([`/${path}`], {
        state: { params: params },
      });
    }
  }

  goHomePage() {
    this.router.navigateByUrl("/HomePage");
  }

  async navigateDeposits() {
    if (this.globalVars.FEATURES.DepOnlineEnabled || this.globalVars.FEATURES.DepLocalEnabled) {
      if (this.isMobile) {
        this.router.navigateByUrl("/HomePage");
      } else {
        this.globalVars.rootScope.openModalOrPage(
          `${PAYMENTS_PATHS.BASE}/${PAYMENTS_PATHS.CashierPage}`,
          {},
          true,
          "modalCashier is-modal",
        );
      }
      this.trackingService.trackEvent(["ClickOpenCashier", "TopRibbon", "", "event"]);
    } else {
      this.utils.alert(false, "", this.translate.instant("m_menu_serverFail"), "OK");
    }
  }

  async openModalLogin(params = null) {
    this.globalVars.afterLoginUrl = null;

    this.globalVars.rootScope.openLogin(() => {
      this.events.publish("navbarpc:refresh");
    });
  }

  backToHome() {
    this.router.navigateByUrl("/");
  }

  refreshBalance() {
    this.trackingService.track({ eventType: EventTypes.RefreshBalance, description: "Refrescar saldo" });
    this.balancesService.refreshBalance();
  }

  showBalanceDetails(event: any): void {
    if (!this.balancePopoverAvailable()) return;
    this.trackingService.track({
      eventType: EventTypes.ShowBalanceDetails,
      description: "Muestra detalles del balance",
    });
    this.events.publish("popover:open", this.balancesService);
    this.balancesService.showBalanceDetails(event, this.popoverController);
  }

  // TODO No se utiliza
  // redirect(item: any) {
  //   //** TODO */
  //   // this.globalVars.gNav.setRoot(NowLiveDetailPage, { item: item });
  // }

  openMisApuestas() {
    const filterParam = { dateValue: 0, typeValue: 1 };
    this.router.navigate([SPORTS_PATHS.MisApuestasPage], { state: { params: filterParam } });
  }

  goUserMessagesPage() {
    this.router.navigateByUrl(`/${MSO_PATHS.BASE}/${MSO_PATHS.UserMessagesPage}`);
  }
  goContactPage() {
    this.router.navigateByUrl(`/${MSO_PATHS.BASE}/${MSO_PATHS.ContactPage}`);
  }

  doLogout() {
    //logout
    this.events.publish("user:logout", TypeLogout.MANUAL);
    this.events.publish("navbarpc:refresh");
    // this.ticketService.clearOrder().subscribe(
    //   () => {
    //     this.globalVars.freeBetIdSelected = '';
    //     // this.ticketService.init();
    //     this.events.publish('user:logout');
    //     this.events.publish('navbarpc:refresh');
    //   },
    //   () => {
    //     this.globalVars.freeBetIdSelected = '';
    //     // this.ticketService.init();
    //     this.events.publish('user:logout');
    //     this.events.publish('navbarpc:refresh');
    //   }
    // );
  }

  openRegistro() {
    this.globalVars.rootScope.openRegistro();
  }

  isActive(component: any) {
    const url = this.router.url;
    const currentRoute = this.router.url?.split("?")[0]?.toLowerCase();
    const componentRoute = component.path?.toLowerCase();
    // Check whether Deportes btn link should be active when navigating between selected pages
    const showActiveDeportesRoutes = [
      SPORTS_PATHS.EventoPage,
      SPORTS_PATHS.EventoSpecialPage,
      SPORTS_PATHS.HorsesMarketPage,
      SPORTS_PATHS.HorsesPage,
      SPORTS_PATHS.MercadosPage,
      SPORTS_PATHS.NowLiveDetailPage,
      SPORTS_PATHS.SportCountriesPage,
      SPORTS_PATHS.CreaTuApuestaPage,
      SPORTS_PATHS.SpecialTeamPage,
      SPORTS_PATHS.TodayPage,
    ];
    if (
      showActiveDeportesRoutes.some((path) => currentRoute.toUpperCase().includes(path.toUpperCase())) &&
      componentRoute === "homepage"
    ) {
      return true;
    }
    if (currentRoute.includes("casino")) {
      const lobby = component.params?.lobby;
      const parseUrl = url.replace(/%20/g, " ");
      if (parseUrl.includes(lobby)) {
        return true;
      }
    } else {
      return currentRoute.includes(componentRoute);
    }
  }

  getFeature(component: any) {
    const feature =
      // eslint-disable-next-line no-nested-ternary
      component?.feature === "false" ? false : component?.feature === undefined ? false : component?.feature;
    return feature;
  }

  get isRegistro() {
    return this.globalVars.rootScope.registerPages.some((page) => this.router.url.includes(page));
  }

  balancePopoverAvailable(): boolean {
    const allLobbyCasinoPages = [
      CASINO_PATHS.SlotsPage,
      CASINO_PATHS.OmnichannelPage,
      CASINO_PATHS.AviatorPage,
      CASINO_PATHS.VIPPage,
      CASINO_PATHS.CasinoEnVivoPage,
    ];
    const single = "singleGame=true";
    const isSingle = this.router.url.includes(single);
    if (this.globalVars.LICENSE_TYPE === LicenseTypes.Panama) {
      return this.balancesService.inCasinoPanama() && !isSingle && this.globalVars.FEATURES.balanceCasinoDetails;
    } else {
      return (
        !allLobbyCasinoPages.some((element) => this.router.url.includes(element)) &&
        !isSingle &&
        this.globalVars.FEATURES.balanceCasinoDetails
      );
    }
  }

  changeLogo() {
    this.userServiceMSO
      .getLogoHeader()
      .pipe(take(1))
      .subscribe((data) => {
        const datenow = new Date();
        const dateend = new Date(data.dateEnd);
        const datestar = new Date(data.dateStart);
        if (datenow >= datestar && datenow <= dateend) {
          this.headerImg = {
            imgClass: {
              common: data.classImgSpecialDesktop,
              sport: data.classImgSpecialDesktopSport,
              casino: data.classImgSpecialDesktopCasino,
            },
            imgSrc: data.specialImg,
            imgSrcCas: data.specialImgCas,
            imgSrcSport: data.specialImgSport,
          };
        } else {
          this.headerImg = {
            imgClass: {
              common: data.classImgDesktop,
              sport: data.classImgSportDesktop,
              casino: data.classImgCasinoDesktop,
            },
            imgSrc: data.commonImg,
            imgSrcCas: data.commonImgCas,
            imgSrcSport: data.commonImgSport,
          };
        }
        this.cdr.detectChanges();
        this.cdr.markForCheck();
      });
  }

  public async ourSalas() {
    const url = "https://bingos.codere.com.ar/";
    this.utils.openExternalLinkNative(url);
  }

  getUrl(): string {
    return this.router.url;
  }
}
